<div class="special-file-upload with-label-icon {{classImage}}"
    [ngClass]="{'data-required':control.touched && control.invalid && inProgress!==true}">



    <div [ngClass]="{'d-none':inProgress!==true}"
        class="form-control progress-bar progress-bar-striped progress-bar-animated" role="progressbar"
        attr.aria-valuenow="{{progressPercentaje}}" aria-valuemin="0" aria-valuemax="100"
        [ngStyle]="{width:progressPercentaje+'%'}">
        {{progressPercentaje}}%</div>

    <div class="pseudo-btn-file pseudo-control {{control.touched && control.invalid && inProgress!==true? 'is-invalid': ''}}"
        [title]="title" [innerText]="placeholder" (click)="onClickPseudoBtn($event)"
        [ngClass]="{'d-none':control.value || inProgress===true}">
    </div>

    <input #inputFile type="file" (change)="onSelectFile($event)" class="file-input-upload accesibleHidden" [id]="id"
        [title]="title" [accept]="format" />

    <div class="file-upload-ctn no-border" [ngClass]="{'d-none':!control.value || inProgress===true}">
        <div class="file-ctn">
            <div class="file-img-preview-wrap" [ngClass]="{'d-none':!urlImage}">
                <img class="file-img-preview" [src]="urlImage" />
            </div>
            <div class="file-name-wrap">
                <span class="file-name">{{fileName}}&nbsp;</span>
                <button class="remove-file btn btn-sm" type="button" title="Eliminar" (click)="removeFile()">
                    <i class="pj-ico pj-ico-modal-error my-icon"></i>
                </button>
            </div>
        </div>
    </div>


</div>

<div-validation-message [ngClass]="{'d-none':inProgress===true}" [control]="control"
[messageRequired]="messageRequired"></div-validation-message>

